import { Ref } from "react";
import { IMaskMixin } from "react-imask";
import CustomInput from "../CustomInput";

/**
 * @component
 * Компонент поля маски
 * @example Пример для номера телефона mask={"+7 (000) 000-00-00"}
 * @description
 * Текстовое поле с маской
 */

const InputMask = IMaskMixin(({ inputRef, hasError, ...props }) => {
  return <CustomInput {...props} ref={inputRef as Ref<HTMLInputElement>} hasError={hasError} />;
});

export default InputMask;